import React, { useEffect, useState } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
  useNavigate,
} from "react-router-dom";

import LoginPage from "../component/authentication/login/Login";
import Topbar from "../component/Topbar/Topbar";
import ForgetPassword from "../component/authentication/forgetPassword/ForgetPassword";
import ResetPassword from "../component/authentication/resetPassword/ResetPassword";
import Homepage from "../component/home/Home";
import ProtectedRoute from "../utils/ProtectedRoutes";
import WelcomeAnimation from "../component/global/WelcomeAnimation";
import SessionTimeoutModal from "../component/global/SessionTimeoutModal";
import useIdleTimeout from "../utils/idleScreenTimeOut";

const IDLE_TIME = 60 * 60 * 1000; // 20 minutes

const AppRoutes = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [showWelcome, setShowWelcome] = useState(false);
  const [showSessionModal, setShowSessionModal] = useState(false);

  const isLoginPage = location.pathname === "/";

  const logout = () => {
    document.cookie =
      "access_token=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;";
    document.cookie =
      "refresh_token=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;";

    localStorage.clear();
    sessionStorage.clear();

    localStorage.setItem("MYAHANA_LOGOUT", Date.now());

    setShowSessionModal(false);
    navigate("/", { replace: true });
  };

  /* Hook is ALWAYS called (safe) */
  useIdleTimeout(
    IDLE_TIME,
    () => {
      setShowSessionModal(true);
    },
    !isLoginPage
  );

  /* Sync logout across tabs */
  useEffect(() => {
    const syncLogout = (e) => {
      if (e.key === "MYAHANA_LOGOUT") {
        navigate("/", { replace: true });
      }
    };
    window.addEventListener("storage", syncLogout);
    return () => window.removeEventListener("storage", syncLogout);
  }, [navigate]);

  /* Welcome animation */
  useEffect(() => {
    setShowWelcome(location.pathname === "/home");
  }, [location.pathname]);

  return (
    <>
      <Topbar />

      {/* {showWelcome && <WelcomeAnimation />} */}

      <SessionTimeoutModal
        open={showSessionModal}
        onLogout={logout}
      />

      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/forget-password" element={<ForgetPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />

        {[
          "/home",
          "/hr",
          "/delete",
          "/comment",
          "/menus",
          "/peoplefinder",
          "/Skill-finder",
          "/CommitteesPanelsCohorts",
          "/CommitteeAdmin",
        ].map((path) => (
          <Route
            key={path}
            path={path}
            element={
              <ProtectedRoute>
                <Homepage />
              </ProtectedRoute>
            }
          />
        ))}
      </Routes>
    </>
  );
};

export default function Routers() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}
